import type { ReactNode } from "react";
import { Lock as LockIcon } from "@tamagui/lucide-icons";
import { ParagraphSmall, YStack } from "@medbillai/ui";
export type LinkingProgressLayoutProps = {
  topSection: ReactNode;
  bottomSection: ReactNode;
};
const PrivacyFooter = () => <YStack justifyContent="flex-end" alignItems="center" gap="$2" $platform-web={{
  paddingBottom: "$4.5"
}} data-sentry-element="YStack" data-sentry-component="PrivacyFooter" data-sentry-source-file="LinkingProgressLayout.tsx">
    <LockIcon color="$iconSubtle" size={12} strokeWidth={2.5} data-sentry-element="LockIcon" data-sentry-source-file="LinkingProgressLayout.tsx" />
    <ParagraphSmall theme="alt1" maxWidth={260} textAlign="center" data-sentry-element="ParagraphSmall" data-sentry-source-file="LinkingProgressLayout.tsx">
      Granted fully encrypts all your data and safely stores your login
      information.
    </ParagraphSmall>
  </YStack>;
export const LinkingProgressLayout = ({
  topSection,
  bottomSection
}: LinkingProgressLayoutProps) => {
  return <YStack f={1} position="relative" data-sentry-element="YStack" data-sentry-component="LinkingProgressLayout" data-sentry-source-file="LinkingProgressLayout.tsx">
      <YStack position="absolute" top={0} left={0} right={0} height="50%" jc="center" ai="center" data-sentry-element="YStack" data-sentry-source-file="LinkingProgressLayout.tsx">
        {topSection}
      </YStack>

      <YStack position="absolute" bottom={0} left={0} right={0} height="50%" ai="center" jc="space-between" gap="$4" data-sentry-element="YStack" data-sentry-source-file="LinkingProgressLayout.tsx">
        <YStack jc="center" ai="center" f={1} data-sentry-element="YStack" data-sentry-source-file="LinkingProgressLayout.tsx">
          {bottomSection}
        </YStack>
        <PrivacyFooter data-sentry-element="PrivacyFooter" data-sentry-source-file="LinkingProgressLayout.tsx" />
      </YStack>
    </YStack>;
};